<template>
    <div class="display-leito opaco" :id="'cat' + indexexterno + 'leito' + index" :class="status">
        <div class="cod_enf_leito mt-1" >
            <span class="cod_enfermaria">{{dados.codigoEnfermaria}}</span>
            <span class="cod_leito">{{dados.codigoLeito}}</span>
        </div>
        <div class="linha_divisoria"></div>
        <figure class="icone_leito">
            <img src="/publico/img/icone_leito.svg" alt="">
        </figure>

        <div :id="'cat' + indexexterno + 'tooltip-container' + index" style="display: none;">
            <strong>{{dados.nomeTipoClinico}}</strong>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/themes/light-border.css'
export default {
    props: {
        dados: Object,
        index: Number,
        indexexterno: Number
    },
    mounted() {
        let conteudo = document.querySelector("#cat" + this.indexexterno + "tooltip-container" + this.index).innerHTML

        tippy('#cat' + this.indexexterno + 'leito' + this.index,
                {
                    animation: 'shift-away',
                    theme: 'azulprefeitura',
                    arrow: true,
                    content: conteudo
                }
            );
    },
    watch: {
        dados (value) {
            let tooltip = document.querySelector('#cat' + this.indexexterno + 'leito' + this.index)

            setTimeout(() => {
                let conteudo = document.querySelector("#cat" + this.indexexterno + "tooltip-container" + this.index).innerHTML
                tooltip._tippy.set({
                    content: conteudo,
                })
            }, 100)
        }
    },
    computed: {
        status () {
            if (this.dados.leitoStatus == 0) return 'livre'
            if (this.dados.leitoStatus == 1) return 'ocupado'
            if (this.dados.leitoStatus == 2) return 'impedido'
            if (this.dados.leitoStatus == 3) return 'cedido'
            if (this.dados.leitoStatus == 4) return 'regulado'
        }
    }
}
</script>

<style>
    
</style>
